import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import PrintQuote from "@/components/PrintQuote";
import Landing from "@/components/landing/Landing";
import { isLandingHost, isAdminHost } from "@/lib/site";
import AdminApp from "@/components/admin/AdminApp";
import { initAnalytics, pingVisit } from "@/lib/analytics";
import { applySiteTheme, getSiteTheme } from "@/lib/siteTheme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const printMatch = window.location.pathname.match(/^\/print\/([A-Za-z0-9_-]+)\/?$/);
if (!printMatch && !isAdminHost()) {
  const site = isLandingHost() ? "landing" : "app";
  initAnalytics(site);
  pingVisit(site);
  applySiteTheme(getSiteTheme());
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(printMatch ? <PrintQuote token={printMatch[1]} /> : isAdminHost() ? <AdminApp /> : isLandingHost() ? <Landing /> : 
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
